import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { lazy, Suspense } from 'react';
import { BrandedLoading } from '@/components/ui/branded-loading';
import { AuthProvider } from './contexts/AuthContext';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import { registerSW } from 'virtual:pwa-register';

const App = lazy(() => import('./App'));

// Register service worker with immediate update
const updateSW = registerSW({
  immediate: true,
  onNeedRefresh() {
    if (confirm('新しいバージョンが利用可能です。更新しますか？')) {
      updateSW();
    }
  },
  onOfflineReady() {
    console.log('アプリがオフラインで利用可能になりました');
    // Show a notification to the user
    if ('Notification' in window && Notification.permission === 'granted') {
      new Notification('温泉ライフ', {
        body: 'アプリがオフラインで利用可能になりました',
        icon: '/pwa-192x192.png'
      });
    }
  },
  onRegisteredSW(swUrl, r) {
    r && setInterval(async () => {
      if (!(!r.installing && !r.waiting)) {
        return;
      }
      const resp = await fetch(swUrl, {
        cache: 'no-store',
        headers: {
          'cache': 'no-store',
          'cache-control': 'no-cache',
        },
      });
      if (resp?.status === 200) {
        await r.update();
      }
    }, 60 * 60 * 1000); // Check every hour
  }
});

// Request notification permission for PWA
if ('Notification' in window && Notification.permission !== 'denied') {
  // Wait for user interaction before requesting permission
  document.addEventListener('click', () => {
    if (Notification.permission === 'default') {
      Notification.requestPermission();
    }
  }, { once: true });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <HelmetProvider>
      <AuthProvider>
        <Suspense fallback={<BrandedLoading size="lg" className="min-h-screen flex-center" />}>
          <App />
        </Suspense>
      </AuthProvider>
    </HelmetProvider>
  </StrictMode>
);